import type { BreadcrumbItemType } from 'antd/es/breadcrumb/Breadcrumb'
import Link from 'next/link'
import { useMemo } from 'react'

import { MainWrapp, SBreadcrumb, SWrapp } from './Breadcrumbs.styled'

type TBreadcrumb = {
  label: string
  href: string
}

interface IBreadcrumbsProps {
  items: Array<TBreadcrumb>
}

export const Breadcrumbs = ({ items }: IBreadcrumbsProps) => {
  const breadcrumbs = useMemo<BreadcrumbItemType[]>(
    () =>
      items.map((breadcrumb, index) => ({
        title:
          index === items.length - 1 ? (
            breadcrumb.label
          ) : (
            <Link href={breadcrumb.href}>{breadcrumb.label}</Link>
          ),
      })),
    [items],
  )

  return (
    <SWrapp>
      <MainWrapp>
        <SBreadcrumb separator="•" items={breadcrumbs} />
      </MainWrapp>
    </SWrapp>
  )
}
